<template>
  <div class="animated fadeIn">
      <div class="cardheading">
        <h4><i class="fa fa-user"></i><span class="ml-1">Users</span></h4>
  			<div class="">
  				<h1 class="my-auto tableName"></h1>
  			</div>
  			<div class="">
  				<router-link to="/users/new">
                  <p class="my-0">
                  <span class="btn btn-success new-cat-btn-name p-2">
                      Create New User <b> + </b>
                  </span>
                  </p>
  				</router-link>
  			</div>
  		</div>
      <div class="card">
        <div class="card-body">
          <v-server-table :columns="columns" :options="options">
            <template slot="action" slot-scope="props">
              <div>
                <router-link :to="`/users/show/${props.row.id}`">
                              <span class="btn btn-primary btn-sm m-1" data-toggle="tooltip" data-placement="top" title="View">
                                  <CIcon name="cil-magnifying-glass" size="sm" />
                              </span>
                </router-link>
                <router-link :to="`/users/edit/${props.row.id}`">
                  <span class="btn btn-warning btn-sm m-1" data-toggle="tooltip"  data-placement="top" title="Edit"> <CIcon name="cil-pencil" size="sm" /></span>
                </router-link>
                <router-link to="" >
                  <span @click="handleDelete(props.row)" class="btn btn-danger btn-sm m-1" data-toggle="tooltip"  data-placement="top" title="Delete"> <CIcon name="cil-basket" size="sm" /></span>
                </router-link>
              </div>
            </template>
          </v-server-table>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios';
import paginate from 'vuejs-paginate';
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

export default {
    name: 'Users',
    data() {
        var url = `${ADMIN_URL}/users`;
        return {
            users: [],
            columns: ['id', 'name','phone','action'],
            options: {
             requestFunction(data) {
                data.limit = 30;
                return axios.get(url, {
                    params: data
                })
              },

               responseAdapter({data}) {
                return data;
              },

              pagination: {nav: 'fixed'},
              filterByColumn: true,
              toMomentFormat: 'YYYY-MM-DD',
              sortIcon: {base: 'fa fa-sort', up: 'fa fa-sort-up', down: 'fa fa-sort-down', is: 'fa fa-sort'},
            
            }
        }
    },
  
    methods: {
        handleDelete(parm) {
            if (confirm('Are you sure?') ) {
                const user_id = parm.id;
                axios.delete(`${ADMIN_URL}/users/${user_id}`)
                .then(response => {
                    alert('User Deteted Successfully');
                    this.fetchUsers();
                }).catch(error => {

                })

            } else {
               
            }
        },
      
    }
}
</script>

<style scoped>

</style>
